import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_4y4cnyncta: FaireCollectionEntity = {
  token: "pbc_4y4cnyncta",
  type: "collection",
  name: "jotter pens",
  heroImageUrl:
    "https://cdn.faire.com/fastly/16b99725ad8077a899458291060768fcfff358d417f080cb238a9a10a612eada.jpeg",
  itemCount: 1,
  description:
    "Jotter pen with a handwritten sentiment on the side. Matte finish for easy gripping. Smooth black gel ink for seamless writing.&nbsp;",
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:23.820Z",
    importedBy: "entity-db-import-collections",
  },
};
